/* eslint-disable @typescript-eslint/no-explicit-any */
import './App.css'
import { BrowserRouter } from 'react-router-dom';
import MainRoute from './routes/MainRoute';
import { Toaster } from './components/ui/sonner';
import { useAppStore } from './store/appStore';
import { useEffect, useState } from 'react';
import { GlobalErrorDialog } from './components/global-error-dialog';
import { getUserInfo } from './services/userService';
import Header from './layout/Header';
import Footer from './layout/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const loadInitialData = useAppStore((state) => state.loadInitialData);
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
  },[])

  useEffect(() => {
    // Check if user is logged in before loading initial data
    const checkAuthAndLoadData = () => {
      try {
        const user:any = getUserInfo();
        
        if (user) {       
          if (user && user.role && !hasInitialized) {
            console.log("Loading initial data for authenticated user");
            loadInitialData();
            setHasInitialized(true);
          }
        }
      } catch (error) {
        console.error("Error checking auth status:", error);
        // Clear invalid session data
        sessionStorage.removeItem("userInfo");
      }
    };

    checkAuthAndLoadData();

    // Listen for storage changes (when user logs in/out in another tab)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'user') {
        if (e.newValue) {
          // User logged in
          if (!hasInitialized) {
            checkAuthAndLoadData();
          }
        } else {
          // User logged out
          setHasInitialized(false);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [loadInitialData, hasInitialized]);

  return (
    <>
      <BrowserRouter>
      <ScrollToTop />
        <Header />
        <MainRoute />
        <Footer />
      </BrowserRouter>
      <Toaster />
      <GlobalErrorDialog />
    </>
  );
}

export default App